import { useLocation } from "react-router-dom";
import { useCustomSearchParams } from "@services/common/hooks/useSearchParams";

export const usePreservedListPage = (): [
  number | undefined,
  (page: number) => void
] => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useCustomSearchParams();

  const preservedPage = location.state?.page as number | undefined;

  const setPreservedPage = (page: number) => {
    setSearchParams(searchParams, {
      replace: true,
      state: { ...(location.state as any), page },
    });
  };

  return [preservedPage, setPreservedPage];
};
